export const PENDING_STATUS = 'PENDING';
export const SUCCESS_STATUS = 'SUCCESS';
